import { BACKEND_BASE_URL } from '@/config.ts'
import axios from 'axios'

export const getUser = async () => {
  const { data } = await axios.get(`${BACKEND_BASE_URL}/api/me`)
  return data
}

export const logout = async () => {
  await axios.post(`${BACKEND_BASE_URL}/api/logout`)
}
